<ng-container [formGroup]="metadataFormGroup">
  <div class="d-flex gap-5">
    <div class="form-check">
      <input
        class="form-check-input"
        id="baseInsuranceCheckbox"
        type="checkbox"
        [(ngModel)]="withBaseInsurance"
        name="withBaseInsurance"
        [ngModelOptions]="{ standalone: true }"
      />
      <label class="form-check-label" for="baseInsuranceCheckbox" i18n
        >Assurance de base</label
      >
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        id="supplementaryInsuranceCheckbox"
        type="checkbox"
        [(ngModel)]="withSupplementaryInsurance"
        name="withSupplementaryInsurance"
        [ngModelOptions]="{ standalone: true }"
      />
      <label class="form-check-label" for="supplementaryInsuranceCheckbox" i18n
        >Assurance complémentaire</label
      >
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label>NPA</label>
      <input
        class="form-control"
        formControlName="postalCode"
        type="number"
        min="0"
      />
    </div>
    <div class="col">
      <label>Commune</label>
      <input class="form-control" formControlName="city" type="text" />
    </div>
  </div>
  <div class="row my-3" *ngIf="withBaseInsurance">
    <div class="col">
      <label>Date de début d'assurance LAMAL</label>
      <input
        class="form-control"
        [(ngModel)]="startDate"
        name="startDate"
        type="date"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3" *ngIf="withBaseInsurance">
    <div class="col">
      <label>Assurance de base</label>
      <select class="form-control" formControlName="baseInsurance">
        <option *ngFor="let value of baseInsuranceValues" [ngValue]="value">
          {{ getBaseInsuranceLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label>Franchise</label>
      <input class="form-control" formControlName="franchise" type="number" />
    </div>
  </div>
  <div class="row my-3" *ngIf="withSupplementaryInsurance">
    <div class="col">
      <label>Date de début d'assurance LCA</label>
      <input
        class="form-control"
        [(ngModel)]="startDatePrestation"
        name="startDatePrestation"
        type="date"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <ng-container *ngIf="withSupplementaryInsurance">
    <div class="row row-cols-md-2 row-cols-1 my-3" *ngIf="withBaseInsurance">
      <div class="col">
        <label>Moyen de paiement</label>
        <select
          class="form-control"
          name="paymentMethod"
          formControlName="paymentMethod"
        >
          <option *ngFor="let option of paymentMethodValues" [ngValue]="option">
            {{ getPaymentMethodLabel(option) }}
          </option>
        </select>
      </div>
      <div class="col">
        <label>Fréquence de paiement</label>
        <select
          class="form-control"
          name="paymentMethod"
          formControlName="paymentFrequency"
        >
          <option
            *ngFor="let option of paymentFrequencyValues"
            [ngValue]="option"
          >
            {{ getPaymentFrequencyLabel(option) }}
          </option>
        </select>
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-1 my-3">
      <div class="col">
        <label>IBAN</label>
        <input class="form-control" formControlName="iban" type="text" />
      </div>
      <div class="col">
        <label>Nom et adresse de la banque</label>
        <input
          class="form-control"
          formControlName="bankNameAddress"
          type="text"
        />
      </div>
    </div>
    <div class="row row-cols-md-2 row-cols-md-1 my-3">
      <div class="col-8">
        <label>Numéro AVS</label>
        <input class="form-control" formControlName="avsNumber" type="text" />
      </div>
      <div class="col-4">
        <label>Profession</label>
        <input
          type="text"
          class="form-control"
          name="job"
          formControlName="job"
        />
      </div>
    </div>

    <ng-container formGroupName="doctor">
      <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
        Nom et adresse du médecin qui connait le mieux l'état de santé de la
        personne
      </div>
      <div class="row my-2">
        <div class="col-md-6">
          <label i18n>Prénom</label>
          <input
            class="form-control"
            type="text"
            name="firstname"
            formControlName="firstname"
          />
        </div>

        <div class="col-md-6">
          <label i18n>Nom</label>
          <input
            class="form-control"
            type="text"
            name="lastname"
            formControlName="lastname"
          />
        </div>
      </div>

      <div class="row my-2">
        <div class="col-md-8">
          <label i18n>Rue </label>
          <input
            class="form-control"
            type="text"
            name="street"
            formControlName="street"
          />
        </div>

        <div class="col-md-4">
          <label i18n>Numéro</label>
          <input
            class="form-control"
            type="text"
            name="streetNumber"
            formControlName="streetNumber"
          />
        </div>
      </div>

      <div>
        <label i18n>Ville</label>
        <input
          class="form-control"
          type="text"
          name="city"
          formControlName="city"
        />
      </div>
    </ng-container>

    <ng-container formGroupName="currentInsurance">
      <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-16" i18n>
        Indications concernant l'assurance de base précédente
      </div>
      <div
        [ngClass]="{ 'row row-cols-1': true, 'row-cols-md-3': hasInsurer() }"
      >
        <div class="col">
          <label class="mb-1" i18n>Assureur maladie actuel </label>
          <select class="form-control" name="name" formControlName="name">
            <option [ngValue]="noInsurer" i18n style="font-weight: 700">
              Aucun
            </option>
            <option [ngValue]="insurer" *ngFor="let insurer of insurersList">
              {{ insurer }}
            </option>
          </select>
        </div>
        <ng-container *ngIf="hasInsurer()">
          <div class="col">
            <label class="mb-1" i18n>Numéro d'assuré précédent</label>
            <input
              class="form-control"
              type="text"
              name="associateNumber"
              formControlName="associateNumber"
            />
          </div>
          <div class="col">
            <label class="mb-1" i18n>Fin du contrat</label>
            <input
              class="form-control"
              type="date"
              name="endDate"
              formControlName="endDate"
            />
          </div>
        </ng-container>
      </div>
    </ng-container>
    <div class="row-cols-1 my-3">
      <div class="col form-check">
        <input
          class="form-check-input"
          id="alreadyGMClient"
          type="checkbox"
          formControlName="alreadyGMClient"
        />
        <label class="form-check-label" for="alreadyGMClient" i18n
          >A déjà été client auprès du Groupe Mutuel</label
        >
      </div>
      <div class="col form-check">
        <input
          class="form-check-input"
          id="alreadySwicaClient"
          type="checkbox"
          formControlName="alreadySwicaClient"
        />
        <label class="form-check-label" for="alreadySwicaClient" i18n
          >A déjà été client auprès de Swica</label
        >
      </div>
      <div class="col form-check">
        <input
          class="form-check-input"
          id="alreadyHelsanaClient"
          type="checkbox"
          formControlName="alreadyHelsanaClient"
        />
        <label class="form-check-label" for="alreadyHelsanaClient" i18n
          >A déjà été client auprès de Helsana</label
        >
      </div>
      <div class="col form-check">
        <input
          class="form-check-input"
          id="alreadyCssClient"
          type="checkbox"
          formControlName="alreadyCssClient"
        />
        <label class="form-check-label" for="alreadyCssClient" i18n
          >A déjà été client auprès de CSS</label
        >
      </div>
    </div>
    <ng-container formGroupName="healthInfo">
      <div class="form-subtitle flex-basis-100 mb-16 text-16" i18n>
        Questionnaire médical
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Au cours des 10 dernières années, a-t-il suivi un traitement
            stationnaire (hôpital, clinique de sevrage, cure, réadaptation,
            etc.) ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hospitalStay"
              id="hospitalStayFalse"
              [value]="false"
              formControlName="hospitalStay"
            />
            <label class="form-check-label" for="hospitalStayFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hospitalStay"
              id="hospitalStayTrue"
              [value]="true"
              formControlName="hospitalStay"
            />
            <label class="form-check-label" for="hospitalStayTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Au cours des 5 dernières années a-t-il consulté un médecin (médecin
            de famille, psychiatre, etc.) ou un thérapeute (médecine
            alternative, physiothérapie, consultations diététiques, etc.) ou
            alors communiqué un diagnostic ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasTreatment"
              id="hasTreatmentFalse"
              [value]="false"
              formControlName="hasTreatment"
            />
            <label class="form-check-label" for="hasTreatmentFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasTreatment"
              id="hasTreatmentTrue"
              [value]="true"
              formControlName="hasTreatment"
            />
            <label class="form-check-label" for="hasTreatmentTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Un implant ou un corps étranger a-t-il été posé (implant mammaire,
            prothèse, prothèses articulaires, anneau gastrique, stent,
            etc) ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasTransplant"
              id="hasTransplantFalse"
              [value]="false"
              formControlName="hasTransplant"
            />
            <label class="form-check-label" for="hasTransplantFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasTransplant"
              id="hasTransplantTrue"
              [value]="true"
              formControlName="hasTransplant"
            />
            <label class="form-check-label" for="hasTransplantTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Prend-il actuellement ou a-t-il pris régulièrement des médicaments
            au cours des 5 dernières années ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasMedication"
              id="hasMedicationFalse"
              [value]="false"
              formControlName="hasMedication"
            />
            <label class="form-check-label" for="hasMedicationFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasMedication"
              id="hasMedicationTrue"
              [value]="true"
              formControlName="hasMedication"
            />
            <label class="form-check-label" for="hasMedicationTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Suit actuellement un traitement ou est-il sur le point d'en suivre
            un auprès d'un médecin, d'un dentiste et/ou d'un thérapeute
            (analyses, opération, traitement de médecine alternative,
            prévention, examen de contrôle, etc) ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasDiagnostic"
              id="hasDiagnosticFalse"
              [value]="false"
              formControlName="hasDiagnostic"
            />
            <label class="form-check-label" for="hasDiagnosticFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasDiagnostic"
              id="hasDiagnosticTrue"
              [value]="true"
              formControlName="hasDiagnostic"
            />
            <label class="form-check-label" for="hasDiagnosticTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Au cours des 5 dernières années, une demande d'assureur de sa part
            à un assureur-maladie, assureur-accidents ou assureur-vie a-t-elle
            été refusée, reportée ou admise seulement à des conditions
            aggravés ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="insuranceRefused"
              id="insuranceRefusedFalse"
              [value]="false"
              formControlName="insuranceRefused"
            />
            <label class="form-check-label" for="insuranceRefusedFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="insuranceRefused"
              id="insuranceRefusedTrue"
              [value]="true"
              formControlName="insuranceRefused"
            />
            <label class="form-check-label" for="insuranceRefusedTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n>Existe-t-il une malposition de la mâchoire ?</label>
          <div class="form-check">
            <input
              type="radio"
              name="jawProblem"
              id="jawProblemFalse"
              [value]="false"
              formControlName="jawProblem"
            />
            <label class="form-check-label" for="jawProblemFalse"> Non </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="jawProblem"
              id="jawProblemTrue"
              [value]="true"
              formControlName="jawProblem"
            />
            <label class="form-check-label" for="jawProblemTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Consomme-t-il régulièrement ou a-t-il consommé régulièrement de la
            nicotine ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="isSmoker"
              id="isSmokerFalse"
              [value]="false"
              formControlName="isSmoker"
            />
            <label class="form-check-label" for="isSmokerFalse"> Non </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="isSmoker"
              id="isSmokerTrue"
              [value]="true"
              formControlName="isSmoker"
            />
            <label class="form-check-label" for="isSmokerTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Consomme-t-il régulièrement ou a-t-il consommé régulièrement de
            l'alcool ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="isDrinker"
              id="isDrinkerFalse"
              [value]="false"
              formControlName="isDrinker"
            />
            <label class="form-check-label" for="isDrinkerFalse"> Non </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="isDrinker"
              id="isDrinkerTrue"
              [value]="true"
              formControlName="isDrinker"
            />
            <label class="form-check-label" for="isDrinkerTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Souffres-t-il d'une infirmité congénitale ou perçoit-il une rente
            LAA ou rente AI ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="birthProblem"
              id="birthProblemFalse"
              [value]="false"
              formControlName="birthProblem"
            />
            <label class="form-check-label" for="birthProblemFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="birthProblem"
              id="birthProblemTrue"
              [value]="true"
              formControlName="birthProblem"
            />
            <label class="form-check-label" for="birthProblemTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >A-t-il déjà souffert d'une maladie tumorale, d'une hernie discale,
            d'une maladie psychique ou d'une maladie cardiovasculaire ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasHeartOrPsychologicalOrTumor"
              id="hasHeartOrPsychologicalOrTumorFalse"
              [value]="false"
              formControlName="hasHeartOrPsychologicalOrTumor"
            />
            <label
              class="form-check-label"
              for="hasHeartOrPsychologicalOrTumorFalse"
            >
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasHeartOrPsychologicalOrTumor"
              id="birthProblemTrue"
              [value]="true"
              formControlName="hasHeartOrPsychologicalOrTumor"
            />
            <label
              class="form-check-label"
              for="hasHeartOrPsychologicalOrTumorTrue"
            >
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >A-t-il déjà subi une intervention en ambulatoire ou
            stationnaire ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasEmergencyIntervention"
              id="hasEmergencyInterventionFalse"
              [value]="false"
              formControlName="hasEmergencyIntervention"
            />
            <label class="form-check-label" for="hasEmergencyInterventionFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasEmergencyIntervention"
              id="hasEmergencyInterventionTrue"
              [value]="true"
              formControlName="hasEmergencyIntervention"
            />
            <label class="form-check-label" for="hasEmergencyInterventionTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >A-t-il déjà eu un accident à la suite duquel il a dû subir une
            intervention chirurgicale ou un traitement ambulatoire et/ou
            hospitalier de plus de quatre semaines (y compris les
            thérapies/médicaments) ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasSurgery"
              id="hasSurgeryFalse"
              [value]="false"
              formControlName="hasSurgery"
            />
            <label class="form-check-label" for="hasSurgeryFalse"> Non </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasSurgery"
              id="hasSurgeryTrue"
              [value]="true"
              formControlName="hasSurgery"
            />
            <label class="form-check-label" for="hasSurgeryTrue"> Oui </label>
          </div>
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >Suit-il actuellement un traitement dentaire ou est-il prévu qu'il
            en suit un ?</label
          >
          <div class="form-check">
            <input
              type="radio"
              name="hasDentalTreatment"
              id="hasDentalTreatmentFalse"
              [value]="false"
              formControlName="hasDentalTreatment"
              (change)="
                metadataFormGroup
                  .get('healthInfo.dentalTreatmentDetails')
                  ?.setValue(null)
              "
            />
            <label class="form-check-label" for="hasDentalTreatmentFalse">
              Non
            </label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="hasDentalTreatment"
              id="hasDentalTreatmentTrue"
              [value]="true"
              formControlName="hasDentalTreatment"
            />
            <label class="form-check-label" for="hasDentalTreatmentTrue">
              Oui
            </label>
          </div>
        </div>
      </div>
      <div
        class="row my-2"
        *ngIf="metadataFormGroup.get('healthInfo.hasDentalTreatment')?.value"
      >
        <div class="col">
          <label i18n for="dentalTreatmentDetails"
            >Traitement dentaire/orthodontique : lequel ?</label
          >
          <input
            class="form-control"
            type="text"
            id="dentalTreatmentDetails"
            name="dentalTreatmentDetails"
            formControlName="dentalTreatmentDetails"
          />
        </div>
      </div>
      <div class="row my-2">
        <div class="col">
          <label i18n
            >A quels intervalles effectue-t-il des contrôles dentaires ?</label
          >
          <div
            class="form-check"
            *ngFor="let dentalIntervalValue of dentalIntervalValues"
          >
            <input
              type="radio"
              name="dentalCheckInterval"
              [id]="'dentalCheckInterval' + dentalIntervalValue"
              [value]="dentalIntervalValue"
              formControlName="dentalCheckInterval"
            />
            <label
              class="form-check-label"
              [for]="'dentalCheckInterval' + dentalIntervalValue"
            >
              {{ getDentalIntervalLabel(dentalIntervalValue) }}
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <label i18n
            >A quels intervalles effectue-t-il des nettoyages dentaires ?</label
          >
          <div
            class="form-check"
            *ngFor="let dentalIntervalValue of dentalIntervalValues"
          >
            <input
              type="radio"
              name="dentalCleaningInterval"
              [id]="'dentalCleaningInterval' + dentalIntervalValue"
              [value]="dentalIntervalValue"
              formControlName="dentalCleaningInterval"
            />
            <label
              class="form-check-label"
              [for]="'dentalCleaningInterval' + dentalIntervalValue"
            >
              {{ getDentalIntervalLabel(dentalIntervalValue) }}
            </label>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
